module.exports = __webpack_public_path__ + "img/oficina-quisapincha.55b74d5a.jpg";